import { StepConnector, stepConnectorClasses } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import React from 'react';

const connectorStyles = (theme) => ({
  connectorActive: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  connectorCompleted: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  connectorDisabled: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.grey[100],
    },
  },
  connectorLine: {
    transition: theme.transitions.create('border-color'),
  },
});

const Connector = withStyles((props) => {
  const { classes } = props;

  return (
    <StepConnector
      classes={{
        active: classes.connectorActive,
        completed: classes.connectorCompleted,
        disabled: classes.connectorDisabled,
        line: classes.connectorLine,
      }}
    />
  );
}, connectorStyles);

export default Connector;
